import { render, staticRenderFns } from "./CompraDadosBasicos.vue?vue&type=template&id=23ba719a"
import script from "./CompraDadosBasicos.vue?vue&type=script&lang=js"
export * from "./CompraDadosBasicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports